export const button = {
  large: 16,
  medium: 14,
  small: 12
}
